// extracted by mini-css-extract-plugin
export default {"box":"MassDeleteAvatars_box__rLc7I","dark":"MassDeleteAvatars_dark__K6VnN"};